import React, {Component} from 'react';

import ProjectContent from '../../../components/ProjectContent';
import '../../../css/views/project.css';
import Objectifs from "../../../components/Objectifs";
import agfa1 from '../../../images/agfa1.png'
import agfa2 from '../../../images/agfa2.png'
import agfa3 from '../../../images/agfa3.png'
import agfa4 from '../../../images/agfa4.png'
import agfa5 from '../../../images/agfa5.png'
import agfa6 from '../../../images/agfa6.png'

export default class Agfa extends Component {
    render() {
        const {img, objectives, objectives2} = this.props;
        return (
            <div>
                <ProjectContent altTitle="Les enjeux pour l’application HEXAGONE WEB">
                    <p className="texte-detail">
                        Hexagone web est une application métier <strong>permettant aux hôpitaux la gestion complète de
                        leur établissement</strong>.
                        L'application est divisée en 3 grands pôles: la gestion des patients, la gestion des ressources
                        humaines et la gestion des achats. AGFA Healthcare fait appel à ARCA pour refondre complètement
                        cet outil et le mettre aux <strong>normes ergonomiques web</strong>. En effet, l'objectif 2019
                        était de développer un outil entièrement manipulable via un navigateur internet, à l'encontre de
                        la version existante qui était une application de bureau.
                    </p>
                </ProjectContent>

                <Objectifs src={img} objectives={objectives}/>

                <ProjectContent altTitle="Les enjeux de l'application KIOSQUE">
                    <p className="texte-detail">
                        Kiosque est un projet complètement innovant et s'adresse aux usagers et aux patients. AGFA
                        Healthcare souhaite d'une part soulager les employés d'accueil des hôpitaux et optimiser les
                        temps d'attente des patients. L'application Kiosque propose ainsi un <strong>portail web pour
                        les patients</strong> afin de les aider et les accompagner dans leurs démarches administratives:
                        ils peuvent ainsi créer ou compléter leur dossier patient en vue d'une admission dans l'hôpital,
                        et peuvent également récupérer des factures ou autres éléments de leur dossier. <br/>
                        Le second aspect complètement innovant de ce projet Kiosque est <strong>le développement d'une
                        application à destination des bornes d'accueil tactiles</strong>, permettant ainsi aux usagers
                        de s'orienter dans l'établissement, ou encore de récupérer un document sans avoir à passer par
                        les files d'attente.
                    </p>
                </ProjectContent>

                <Objectifs src={img} objectives={objectives2}/>

                <ProjectContent altTitle="Identité graphique et ergonomie">
                    <p className="texte-detail">
                        L'outil HEXAGONE WEB étant une application bureautique, et son design se faisant vieillissant,
                        ARCA Computing a
                        été missionné pour <strong>repenser entièrement l'identité visuelle</strong> de l'application.
                        Au niveau graphique, tout a été
                        reconsidéré et revu pour donner une image plus moderne à l'application, et plus en phase avec
                        les standards actuels
                        (comme Material Design). Du côté ergonomique, le travail mené a été de plus grande envergure
                        puisque l'objectif
                        était de transformer l'UX vers des <strong>usages exclusivement web</strong> : un mode de
                        navigation web (menu, sidebar, fil
                        d'Ariane, etc), une expérience utilisateur web (scroll de la page, etc), une organisation des
                        éléments orientée vers un usage web (mise en page standard, formulaires, etc)... Des batteries de <strong>tests
                        utilisateurs</strong> ont été menées en parallèle des
                        travaux de refonte graphique et ergonomique et des développements de cette nouvelle version.
                    </p>
                    <p className="texte-detail">
                        Pour l'application KIOSQUE, deux chantiers sont traités séparément : d'un côté la création du
                        portail patient (site
                        web à destination des patients et accessible hors des hôpitaux) et de l’autre les interfaces de
                        la borne tactile (présente
                        dans les hôtpitaux). Une <strong>même charte graphique</strong> est créée pour les deux
                        applications, afin de rester homogène et de
                        ne pas perdre l'usager. Les applications étant à destination de patient, et donc d'utilisateur
                        n'ayant pas forcément
                        l'habitude d'utiliser des outils web ou tactiles, le challenge a été de créer des <strong>interfaces
                        très intuitives et très
                        simples</strong> dans leur utilisation et leur navigation. Pour les bornes tactiles, l'enjeu du
                        support utilisé s'est ajouté à cet
                        objectif d'<strong>optimisation d'expérience utilisateur</strong>.
                    </p>
                    <div className="caption">
                        <img src={agfa1} alt=""/>
                        <i>
                            La charte graphique de l'application a été totalement revue avec des couleurs plus
                            actuelles, une typographie plus "web" et moderne, et l'utilisation d'icônes. On retrouve
                            notamment un sidebar qui permet ici de naviguer dans les différentes parties du dossier
                            patient.
                        </i>
                    </div>
                    <div className="caption">
                        <img src={agfa2} alt=""/>
                        <i>
                            Dans l'Espace des Ressources Humaines, le collaborateur peut acéder au dossier d'un agent,
                            le consulter, récupérer des documents relatifs à l'agent ou encore y apporter des
                            modifications. L'application permet également toute la gestion de la paie.
                        </i>
                    </div>
                    <div className="caption">
                        <img src={agfa3} alt=""/>
                        <i>
                            Le collaborateur peut également gérer la composition de son établissement, au niveau
                            juridique, comptable et géographique. L'application Hexagone web permet aussi la gestion des
                            achats, notamment au travers des marchés. Un travail très important a été mené pour
                            optimiser l'UX design de cet aspect là.
                        </i>
                    </div>
                    <div className="caption">
                        <img src={agfa4} alt=""/>
                    </div>
                    <div className="caption">
                        <img src={agfa5} alt=""/>
                        <i>
                            Le portail Kiosque permet au patient de gérer son dossier en ligne et de gagner du temps
                            pour son admission à l'hôpital. Le patient peut notamment accéder à la liste de factures ou
                            règlements, ou encore préparer ses rendez-vous à l'hôpital. Le design et l'ergonomie ont été
                            pensés pour mettre en avant la facilité d'utilisation de l'outil, et ainsi inciter davantage
                            les usagers à l'utiliser. L'objectif étant de soulager les zones d'accueil et d'admissions
                            dans les hôpitaux. <br/>
                            Une identité visuelle a été entièrement créée pour le portail web. L'aspect responsive du
                            site n'a bien évidemment pas été mis de côté.
                        </i>
                    </div>
                    <div className="caption">
                        <img src={agfa6} alt=""/>
                        <i>
                            En parallèle du portail web, et toujours dans le même enjeu qui est d'apporter un nouveau
                            service aux usagers et de soulager les bureaux d'accueils et d'admissions, une application à
                            destination des bornes tactiles a été développée. La charte graphique correspond à celle
                            créée pour le portail patient. L'UX design a été spécifiquement étudié pour un usage
                            tactile, et pour des utilisateurs novices. Son utilisation soit donc être la plus simple et
                            intuitive possible.
                        </i>
                    </div>
                </ProjectContent>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/projet/fiches/Agfa.js